import { render } from "./TopbarComponent.vue?vue&type=template&id=84558798&scoped=true"
import script from "./TopbarComponent.vue?vue&type=script&lang=js"
export * from "./TopbarComponent.vue?vue&type=script&lang=js"

import "./TopbarComponent.vue?vue&type=style&index=0&id=84558798&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84558798"]])

export default __exports__